

















































































































































































































































import _ from 'lodash';
import { editFactory } from '@/main/pages';
import { ENTITY } from '@/main/store/listEditTypes';
import { PageMode } from '@/main/utils/pageMode';

import { DefaultCurrency } from '@/modules/servis/zakazka/components/AdvancePay/constants';

import { NAME, TAB_NAMES, TABS } from './constants';
import { store } from './store/edit';

export default editFactory(NAME, store).extend({
	provide() {
		return { pageMode: this.pageMode };
	},
	data() {
		return {
			tabNames: TAB_NAMES,
		};
	},
	computed: {
		tabItems() {
			const tabItems = [];

			if (this.hasTabAccess(NAME, TABS.HlavniUdaje)) tabItems.push(TAB_NAMES.HLAVNIUDAJE);
			if (this.hasTabAccess(NAME, TABS.Nastaveni)) tabItems.push(TAB_NAMES.NASTAVENI);
			if (this.hasTabAccess(NAME, TABS.Mena)) tabItems.push(TAB_NAMES.MENA);
			if (this.hasTabAccess(NAME, TABS.SkladPneu)) tabItems.push(TAB_NAMES.SKLADPNEU);
			if (this.hasTabAccess(NAME, TABS.Kalkulace)) tabItems.push(TAB_NAMES.KALKULACE);
			if (this.hasTabAccess(NAME, TABS.SilverDAT)) tabItems.push(TAB_NAMES.SILVERDAT);
			if (this.hasTabAccess(NAME, TABS.FinStat)) tabItems.push(TAB_NAMES.FINSTAT);
			return _.pick(TABS, tabItems);
		},
		getOrganizationCode() {
			return this.dmsSys.EnableGSTPrp && !this.dmsSys.EnableInvestorDealerPrp ? this.LocalizePopisPoli('TEXT') : this.LocalizePopisostatni('lblInvestorCode');
		},
		getOrganizationName() {
			return this.dmsSys.EnableGSTPrp && !this.dmsSys.EnableInvestorDealerPrp ? this.LocalizePopisPoli('FIRMA') : this.LocalizePopisostatni('lblInvestorName');
		},
		isGstNumberVisible() {
			return this.dmsSys.EnableGSTPrp && !this.dmsSys.EnableInvestorDealerPrp;
		},
		pageMode(): PageMode {
			return PageMode.EDIT;
		},
		menaPrevod() {
			const mena1Txt = this.dropdownList.MenaId.find((item) => item.Value === this.MenaId1)?.Text;
			const mena2Txt = this.dropdownList.MenaId.find((item) => item.Value === this.MenaId2)?.Text ?? '';
			return `${mena1Txt} === 1 ${mena2Txt}`;
		},
		getCurrency() {
			this.MenaId1 = (this.dropdownList.MenaId as any).filter((x:any) => x.Text === DefaultCurrency.PrimaryText || x.Text === DefaultCurrency.SecondaryText)[0]?.Value;
			return this.MenaId1;
		},
	},
	methods: {
		updateAudatexPassword() {
			this.AudatexPassw = btoa(this.AudatexPassw!);
		},
		async baseCreated() {
			this.entityId = '1';
			await this.storeToPageManager();
		},
		async saveClick() {
			await this.save(false);
		},
		entity() {
			return this.$store.dispatch(`${this.storeUri}/${ENTITY}`, { id: this.entityId });
		},
	},
});
